import { OrderFileterDetail } from '../../app/modules/chart/interface/interfaces';
import { ReduxAction, ReduxType } from '../interface';

const data: OrderFileterDetail = {
  column: '',
  dir: ''
};
export default (
  state: OrderFileterDetail,
  action: ReduxAction<OrderFileterDetail>
) => {
  if (!state) {
    state = data;
  }
  if (action.type === ReduxType.OREDER_TABLE) {
    return Object.assign({}, state, action.payload);
  } else {
    return state;
  }
};
